import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { TariffButton } from 'widgets/tariff-button'

import { MyTicketItem } from 'shared/api/MyTicketsModel'
import { priceShow } from 'shared/lib/priceShow'
import { TicketItem } from 'shared/models/ticket'
import { Border } from 'shared/ui/border'
import { MBonusIcons } from 'shared/ui/mbonus/mbonus-icons'
import { TagPayment } from 'shared/ui/mplus/tag-payment'
import { Paper } from 'shared/ui/paper'
import { RadioButtonSecondary } from 'shared/ui/radio-button-secondary'

import { getInfoTicket, getInfoTicketMyTicket } from './lib/info-ticket'
import s from './styles.module.scss'

interface PropsTicketInfo {
  ticket: TicketItem
  isSelected?: boolean
  isFewOptions?: boolean
  onClick?: (ticket: TicketItem) => void
  onShowTariffInfo?: (ticket: TicketItem) => void
}

interface PropsTicketInfoList {
  tickets: TicketItem[]
  passengerCount?: number
  selected?: TicketItem['tid']
  onClick?: (ticket: TicketItem) => void
  onShowTariffInfo?: (ticket: TicketItem) => void
}

const CountTwoOptions = 2

export const InfoTicket = ({
  ticket,
  isSelected,
  isFewOptions,
  onClick,
  onShowTariffInfo,
}: PropsTicketInfo) => {
  const { t } = useTranslation()
  const result = getInfoTicket(ticket)

  return (
    <Paper
      padding={[12, 14]}
      className={clsx(s.container, {
        [s.selectedTicket]: isSelected,
        [s.fewOptions]: isFewOptions,
      })}
      onClick={() => onClick?.(ticket)}
    >
      <div className={s.card}>
        <div className={s.header}>
          <div className={s.left}>
            <p className={clsx('black-22', s.price)}>
              {priceShow(ticket?.price?.KGS)} &#8384;
            </p>

            <p className={clsx('medium-14', s.fareFamilyType)}>
              {ticket?.fare_family_type || t('no_tariff')}
            </p>
          </div>

          {isFewOptions && <RadioButtonSecondary isActive={isSelected} />}
        </div>

        <div className={s.bonus}>
          <TagPayment
            price={ticket?.price?.KGS}
            tranche={ticket?.monthly_tranche}
            mInstallmentInfo={ticket?.minstallment_info}
          />

          {ticket?.is_bonus && (
            <MBonusIcons
              text={t('tickets_page.mbonus_amount', {
                amount: priceShow(ticket?.bonus_amount),
              })}
            />
          )}
        </div>

        <Border />

        <div className={s.body}>
          {result.additionalInfo.map((item) => (
            <div className={s.itemRow}>
              {item.icon}

              <div className={s.itemContent}>
                <p className={clsx('regular-14', s.label)}>{item.label}</p>

                <p className={clsx('regular-14', s.value)}>{item.value}</p>
              </div>
            </div>
          ))}
        </div>

        <Border />

        {onShowTariffInfo && (
          <div
            className={s.tariffButton}
            onClick={(event) => event.stopPropagation()}
          >
            <TariffButton
              type="small"
              onClick={() => onShowTariffInfo(ticket)}
            />
          </div>
        )}
      </div>
    </Paper>
  )
}

export const InfoTicketMyTicket = ({ ticket }: { ticket: MyTicketItem }) => {
  const result = getInfoTicketMyTicket(ticket)

  return (
    <div className={s.container}>
      <p className={clsx('medium-15', s.myTicketFareFamilyType)}>
        {ticket?.fare.fare_family_type}
      </p>

      <div className={s.card}>
        <div className={clsx(s.body, s.myTicket)}>
          {result.additionalInfo.map((item) => (
            <div className={s.itemRow}>
              {item.icon}

              <div className={s.itemContent}>
                <p className={clsx('regular-14', s.label)}>{item.label}</p>

                <p className={clsx('regular-14', s.value)}>{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export const InfoTicketList = ({
  tickets,
  selected,
  onClick,
  passengerCount,
  onShowTariffInfo,
}: PropsTicketInfoList) => {
  const { t } = useTranslation()

  const isFewOptions = tickets?.length >= CountTwoOptions

  return (
    <div className={s.box}>
      <div className={s.titles}>
        <p className={clsx('bold-20', s.title)}>{t('select_tariff')}</p>
        <p className={clsx('regular-13', s.subtitle)}>
          {t('tickets_page.passengers_count', { count: passengerCount })}
        </p>
      </div>

      <div
        className={clsx(s.containerList, {
          [s.fewOptionsContainer]: isFewOptions,
        })}
      >
        {tickets?.map((item) => (
          <InfoTicket
            ticket={item}
            key={item.tid}
            isFewOptions={isFewOptions}
            isSelected={isFewOptions && selected === item.tid}
            onClick={onClick}
            onShowTariffInfo={onShowTariffInfo}
          />
        ))}
      </div>
    </div>
  )
}
